import React, {useState} from 'react';
import {Divider} from "@material-ui/core";
import messages from "res/messages/farsi";

import ICLogo from "res/images/logo_4.png";

export default function BasketChangeSetItem(props) {

    const [product] = useState(props.product ? props.product : undefined)
    const [defaultSrc, setDefaultSrc] = useState(undefined)

    return (<>
        {product &&
        <div className="marginSmall horizontalFullScreen">
            <img style={{height: "6em"}}
                 src={defaultSrc ? defaultSrc : product.image}
                 alt=""
                 onError={() => {
                     setDefaultSrc(ICLogo)
                 }}/>
            <div className="marginLeftSmall">
                <Divider orientation="vertical"/>
            </div>
            <div>
                <div className="mediumTextBold">
                    {product.name}
                </div>
                {product.type === 0 ?
                    <>
                        {product.new_value <= 0 ?
                            <div className="mediumText redColor">
                                {messages.productRemovedFromBasket}
                            </div> :
                            <div className="mediumText redColor">
                                {messages.productCountChangeFrom +
                                product.previous_value + messages.toBe +
                                product.new_value + messages.changed}
                            </div>
                        }
                    </> :
                    <>
                        {product.new_value !== product.previous_value &&
                        <div className="mediumText greenColor">
                            {messages.productPriceChangeFrom +
                            parseInt(product.previous_value).toLocaleString() + messages.toBe +
                            parseInt(product.new_value).toLocaleString() + messages.changed}
                        </div>
                        }
                    </>
                }
            </div>
        </div>
        }
    </>)
}